import { useState, useEffect } from 'react';

function setItem(key, value) {
    try {
        console.log('Setting localStorage item', key, value, JSON.stringify(value));
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.log(error);
    }
}

function getItem(key) {
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : undefined;
    } catch (error) {
        console.log(error);
    }
}

export function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
        const item = getItem(key);
        return item !== undefined ? item : initialValue;
    });

    useEffect(() => {
        setItem(key, value);
    }, [key, value]);

    return [value, setValue];
}
